import styled, { css } from 'styled-components'
import { Flex, scrollbarHidden } from 'vvs-uikit'

export const BasePageContainer = styled(Flex)<{ stretch?: boolean; popup?: boolean }>`
  flex-direction: column;
  overflow: hidden auto;

  ${({ popup }) =>
    popup
      ? css`
          ${scrollbarHidden}
          border-radius: 16px 16px 0 0;
        `
      : `
    flex: 1;
  `}
  width: 100%;
  ${({ stretch }) =>
    stretch &&
    css`
      height: -webkit-fill-available;
    `}
`

export const LightPageContainer = styled(BasePageContainer)`
  background: ${({ theme }) => theme.colors.paleYellow};
`

export const DarkPageContainer = styled(BasePageContainer)`
  background: ${({ theme }) => theme.colors.darkestNightBlue};
`

const mobileNavbarHeight = '77px'

export const VvsGotchiScreen = styled(Flex)`
  width: 100%;
  padding-top: ${mobileNavbarHeight};
  height: calc(100vh - 49px);
  flex-direction: column;
  position: relative;
  background: black;
  overflow: hidden;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: 420px;
    padding-top: 0;
    height: min(calc(100vh - 140px), 600px);
    border: 8px solid black;
    border-radius: 24px;
  }
`

export const StackContentFlex = styled(Flex)`
  overflow: hidden;
  margin-top: ${mobileNavbarHeight};
  ${({ theme }) => theme.mediaQueries.sm} {
    margin-top: 0;
  }
`
export const FullScreenStackContentFlex = styled(StackContentFlex)`
  flex: 1;
`
